// extracted by mini-css-extract-plugin
export default {"root":"payment_providers_list_root__K-jzb","checkIcon":"payment_providers_list_checkIcon__G5sfn","warningIcon":"payment_providers_list_warningIcon__UaXzJ"};